import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

// ✅ get (new)
export const canSendMailService = () => {
    return apiClient(ENDPOINTS.CAN_SEND_MAIL, {
        method: "GET",
    });
};

// ✅ PUT (new)
export const updateCanSendMailService = (enabled) => {
    return apiClient(ENDPOINTS.CAN_SEND_MAIL, {
        method: "PUT",
        body: { condition: enabled ? "Yes" : "No" },
    });
};